import { Col, Row } from "antd";
import React,{ReactComponentElement} from "react"

interface CustomLabelValueType {
  label: string;
  value: string | React.ReactNode;
  alignX?: number;
  isLabelStart?: boolean;
  isLabelEnd?: boolean;
  hasMarginleft?: boolean;
  isGrid?: boolean;
  disableColon?: boolean;
}
function CustomLabelValue({
  label,
  value,
  alignX,
  hasMarginleft = true,
  isGrid = false,
  disableColon = false
}: CustomLabelValueType) {
  if (isGrid) {
    return (
      <Row>
        <Col lg={12} sm={24}
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div>{label}</div>
          <div>{!disableColon && ":"}</div>
        </Col>
        <Col lg={12} sm={24}>&nbsp;{value}</Col>
      </Row>
    );
  }
  return (
    <div
      style={{
        display: "flex",
        marginBottom: 12,
      }}
    >
      <label
        style={{
          display: "inline-block",
          minWidth: alignX ? `${alignX}px` : undefined,
          textAlign: "left",
        }}
      >
        {label}
      </label>
      <span>{!disableColon && ":"}</span>
      <span
        style={{
          display: "inline-block",
          marginLeft: hasMarginleft ? (alignX ? alignX / 2 : 24) : 4,
        }}
      >
        {value}
      </span>
    </div>
  );
}

export default CustomLabelValue;
